import * as React from "react";
const Happy = () => {
  return (
    <svg
      width="300"
      height="233"
      viewBox="0 0 300 233"
      fill="none"
    >
      <path d="M0 0H300V233H0V0Z" fill="url(#paint0_radial_2433_8795)" />
      <path
        d="M300 233V232H0V233V234H300V233Z"
        fill="url(#paint1_linear_2433_8795)"
        mask="url(#path-1-inside-1_2433_8795)"
      />
      <g clip-path="url(#clip0_2433_8795)">
        <path
          d="M162.575 22.2829C162.575 22.2829 177.606 0.1632 196.403 11.186C219.936 24.983 191.506 57.8585 208.905 67.3681C226.305 76.8776 244.204 77.6194 249.279 103.938C255.824 138.326 194.138 186.69 141.91 156.07C89.6821 125.449 108.376 68.1543 132.865 56.7458C162.34 43.023 162.575 22.2829 162.575 22.2829Z"
          fill="#1B1211"
        />
        <path
          d="M184.004 80.9427V104.531C184.066 106.439 183.746 108.34 183.064 110.121C182.382 111.902 181.353 113.526 180.036 114.898C178.72 116.269 177.143 117.36 175.401 118.104C173.658 118.849 171.785 119.233 169.892 119.233C168 119.233 166.126 118.849 164.384 118.104C162.641 117.36 161.065 116.269 159.748 114.898C158.432 113.526 157.402 111.902 156.72 110.121C156.039 108.34 155.719 106.439 155.78 104.531V80.9427H184.004Z"
          fill="#E88C7B"
        />
        <path
          d="M124.938 64.7869C125.359 66.8532 126.377 68.7474 127.865 70.2298C129.353 71.7123 131.243 72.7165 133.297 73.1154C135.351 73.5144 137.475 73.2902 139.403 72.4713C141.33 71.6523 142.973 70.2753 144.125 68.5144C145.276 66.7535 145.884 64.6878 145.872 62.5783C145.86 60.4689 145.227 58.4105 144.055 56.6634C142.883 54.9163 141.224 53.559 139.287 52.763C137.351 51.967 135.223 51.7682 133.175 52.1915C130.428 52.7631 128.019 54.4102 126.474 56.7714C124.93 59.1327 124.378 62.0153 124.938 64.7869Z"
          fill="#E88C7B"
        />
        <path
          d="M140.808 46.9247V64.9054C140.808 64.9054 133.718 58.5558 133.924 46.0791L140.808 46.9247Z"
          fill="#1B1211"
        />
        <path
          d="M127.835 60.7366L136.219 66.4631"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M186.167 62.6353C186.585 64.703 187.602 66.5991 189.088 68.0838C190.575 69.5685 192.465 70.5751 194.519 70.9762C196.573 71.3773 198.699 71.1548 200.627 70.337C202.556 69.5192 204.201 68.1428 205.353 66.3819C206.506 64.621 207.115 62.5548 207.104 60.4446C207.092 58.3344 206.46 56.2751 205.288 54.5273C204.116 52.7794 202.456 51.4215 200.519 50.6254C198.581 49.8293 196.453 49.6307 194.404 50.0548C193.043 50.3343 191.751 50.8816 190.601 51.6654C189.45 52.4491 188.464 53.454 187.699 54.6225C186.934 55.7909 186.405 57.1001 186.142 58.475C185.879 59.8499 185.888 61.2637 186.167 62.6353Z"
          fill="#E88C7B"
        />
        <path
          d="M196.521 60.4992C196.521 60.4992 202.566 53.8232 200.448 38.0085H191.962L196.521 60.4992Z"
          fill="#1B1211"
        />
        <path
          d="M194.786 65.2169L202.978 57.1909"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M168.679 18.8114C161.283 18.835 154.198 21.8151 148.976 27.0987C143.754 32.3824 140.822 39.5385 140.822 46.9989V67.457C140.828 69.5878 141.372 71.6819 142.401 73.5427C143.43 75.4034 144.911 76.9696 146.705 78.0941L162.061 87.7372C164.042 88.9969 166.337 89.6654 168.679 89.6654C171.022 89.6654 173.316 88.9969 175.298 87.7372L190.741 78.0199C192.536 76.8955 194.017 75.3292 195.046 73.4685C196.075 71.6077 196.618 69.5136 196.624 67.3829V46.9247C196.605 39.4618 193.652 32.3112 188.413 27.0411C183.175 21.7709 176.078 18.8114 168.679 18.8114Z"
          fill="#E88C7B"
        />
        <path
          d="M155.78 84.0133L162.061 87.9892C164.045 89.2422 166.338 89.9067 168.679 89.9067C171.02 89.9067 173.314 89.2422 175.298 87.9892"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M166.326 18.8264L173.312 67.3831H164.546"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M195.286 61.1967C195.289 62.6204 194.873 64.013 194.091 65.1982C193.309 66.3834 192.196 67.308 190.893 67.8548C189.59 68.4017 188.155 68.5463 186.77 68.2703C185.386 67.9944 184.113 67.3103 183.114 66.3046C182.115 65.2989 181.434 64.0169 181.158 62.6208C180.881 61.2246 181.022 59.7771 181.561 58.4615C182.101 57.1459 183.015 56.0213 184.188 55.23C185.362 54.4387 186.741 54.0164 188.153 54.0164C190.042 54.0164 191.854 54.7724 193.192 56.1185C194.529 57.4647 195.282 59.291 195.286 61.1967Z"
          fill="#E6715C"
        />
        <path
          d="M157.339 61.1967C157.342 62.6204 156.926 64.013 156.144 65.1982C155.362 66.3834 154.249 67.308 152.946 67.8548C151.642 68.4017 150.208 68.5463 148.823 68.2703C147.438 67.9944 146.166 67.3103 145.167 66.3046C144.168 65.2989 143.487 64.0169 143.21 62.6208C142.934 61.2246 143.074 59.7771 143.614 58.4615C144.153 57.1459 145.068 56.0213 146.241 55.23C147.414 54.4387 148.794 54.0164 150.206 54.0164C152.095 54.0164 153.907 54.7724 155.245 56.1185C156.582 57.4647 157.335 59.291 157.339 61.1967Z"
          fill="#E6715C"
        />
        <path
          d="M201.227 15.0433C182.431 4.02049 162.575 22.3127 162.575 22.3127C162.575 22.3127 162.34 43.0824 132.865 56.7904C126.658 59.6833 118.333 69.994 114.436 76.2546C114.436 76.2546 123.04 51.1974 125.761 34.997C128.482 18.7967 142.763 21.2742 142.763 21.2742C142.763 21.2742 151.426 -0.0592812 175.356 0.0445674C191.947 0.0742384 201.227 15.0433 201.227 15.0433Z"
          fill="#322A28"
        />
        <path
          d="M179.71 35.8129C181.946 32.3859 184.122 31.9705 185.593 36.5399L179.71 35.8129Z"
          fill="#1B1211"
        />
        <path
          d="M149.191 37.1184C149.515 33.0238 151.221 31.6145 154.663 34.9376L149.191 37.1184Z"
          fill="#1B1211"
        />
        <path
          d="M151.029 57.2499C151.029 57.2499 152.574 50.3811 156.074 50.3811C159.575 50.3811 161.09 56.4637 161.09 56.4637"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M176.975 56.4195C176.975 56.4195 179.048 49.699 182.534 49.966C186.02 50.233 187.064 56.4195 187.064 56.4195"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M177.254 72.1898C170.003 85.9275 162.737 72.3382 162.737 72.3382L177.254 72.1898Z"
          fill="#1B1211"
        />
        <path
          d="M226.041 202.534C222.694 203.589 219.069 203.262 215.961 201.624C212.853 199.985 210.517 197.17 209.465 193.796L189.786 130.523C188.735 127.145 189.058 123.485 190.682 120.346C192.307 117.208 195.1 114.849 198.449 113.788C200.108 113.264 201.853 113.075 203.585 113.231C205.317 113.387 207.001 113.885 208.541 114.698C210.082 115.511 211.449 116.622 212.564 117.968C213.679 119.314 214.52 120.868 215.039 122.541L235.145 189.182C235.145 189.182 232.998 200.324 226.041 202.534Z"
          fill="#E88C7B"
        />
        <path
          d="M51.8538 173.234C49.674 170.466 48.6713 166.94 49.0655 163.427C49.4598 159.915 51.2189 156.703 53.957 154.497L105.435 113.165C108.18 110.962 111.68 109.948 115.166 110.345C118.652 110.743 121.838 112.52 124.026 115.287C126.21 118.055 127.216 121.586 126.822 125.102C126.427 128.618 124.665 131.832 121.923 134.039L70.5183 175.371C69.1561 176.472 67.5913 177.291 65.914 177.78C64.2367 178.269 62.48 178.419 60.7452 178.22C59.0104 178.022 57.3317 177.479 55.8057 176.623C54.2797 175.768 52.9366 174.616 51.8538 173.234Z"
          fill="#E88C7B"
        />
        <path
          d="M230.32 143.8L205.258 148.147L181.328 162.983L207.538 157.686L230.32 143.8Z"
          fill="#B45458"
        />
        <path
          d="M215.656 121.443L228.511 154.171L190.888 169.036L183.387 146.323L215.656 121.443Z"
          fill="#F27376"
        />
        <path
          d="M234.081 156L212.127 169.256L190.021 175.865L182.137 163.33L207.637 158.176L207.723 158.159L207.798 158.113L230.053 144.548L234.081 156Z"
          fill="#E5E5E8"
          stroke="#E5E5E8"
        />
        <path
          d="M193.389 212.162H140.44L110.833 117.809C109.958 114.952 109.877 111.908 110.6 109.008C111.323 106.109 112.822 103.465 114.933 101.366C117.044 99.2673 119.686 97.7939 122.571 97.1066C125.456 96.4194 128.473 96.5448 131.292 97.4691L172.945 111.474L200.964 110.628C203.303 110.558 205.626 111.042 207.745 112.042C209.865 113.041 211.723 114.529 213.169 116.384C214.616 118.24 215.61 120.412 216.073 122.726C216.535 125.04 216.454 127.431 215.834 129.707L193.389 212.162Z"
          fill="#F27376"
        />
        <path
          d="M186.535 124.292L190.476 98.0926L145.926 93.731L150.073 124.292H186.535Z"
          fill="#F27376"
        />
        <path
          d="M129.82 195.71L203.39 191.69L196.948 210.486L135.689 209.819L129.82 195.71Z"
          fill="#604EA0"
        />
        <path
          d="M196.948 210.486C196.948 210.486 222.143 233.986 223.643 275.911H110.936C110.936 236.508 135.689 209.819 135.689 209.819L196.948 210.486Z"
          fill="#604EA0"
        />
        <path
          d="M168.032 214.729L169.503 245.884C169.503 245.884 163.502 243.436 163.62 233.007"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M210.45 227.799H192.212C192.212 227.799 200.728 247.872 218.819 246.106"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M113.627 248.999C113.627 248.999 127.114 252.263 139.057 232.947"
          stroke="#1B1211"
          stroke-width="0.25"
          stroke-miterlimit="10"
        />
        <path
          d="M150.529 207.282H137.777V213.706H150.529V207.282Z"
          fill="#010101"
        />
        <path
          d="M193.757 207.282H181.005V213.706H193.757V207.282Z"
          fill="#010101"
        />
        <path
          d="M175.827 207.282H156.457V213.706H175.827V207.282Z"
          fill="#010101"
        />
        <path
          d="M170.399 206.491V214.511H161.884V206.491H170.399Z"
          fill="#E5E5E8"
          stroke="#E5E5E8"
        />
        <path
          d="M216.627 279.116L209.376 190.102L235.13 189.138L235.336 190.488C238.807 211.865 238.453 233.697 234.291 254.948L228.746 283.299L216.627 279.116Z"
          fill="#E88C7B"
        />
        <path
          d="M55.8396 152.91C59.5964 150.542 64.1314 149.776 68.4478 150.781C72.7641 151.785 76.5084 154.477 78.8576 158.265L112.098 218.586L101.92 230.455L50.5447 176.097C48.2056 172.312 47.4495 167.746 48.442 163.4C49.4345 159.054 52.0947 155.281 55.8396 152.91Z"
          fill="#E88C7B"
        />
        <path
          d="M107.949 214.907C121.407 214.907 133.585 208.009 133.585 208.009L141.145 231.849C118.995 240.32 107.788 234.742 101.875 230.514L107.949 214.907Z"
          fill="#E88C7B"
        />
        <path
          d="M133.586 208.009C133.586 208.009 145.985 206.896 154.854 212.801L156.457 227.636C156.457 227.636 146.161 224.224 139.469 226.494C139.469 226.494 150.912 228.689 155.354 233.541L152.221 236.745C145.707 234.052 138.631 233.032 131.63 233.778L133.586 208.009Z"
          fill="#E88C7B"
        />
        <path
          d="M155.162 216.598C155.162 216.598 144.867 213.216 137.057 212.993"
          stroke="#1B1211"
          stroke-width="0.25"
          stroke-miterlimit="10"
        />
        <path
          d="M155.883 222.414C149.956 220.179 143.643 219.17 137.321 219.447"
          stroke="#1B1211"
          stroke-width="0.25"
          stroke-miterlimit="10"
        />
        <path
          d="M91.0059 109.07L108.332 127.837L118.466 154.274L100.787 134.039L91.0059 109.07Z"
          fill="#B45458"
        />
        <path
          d="M116.098 100.258L86.2109 118.417L107.229 153.251L126.834 139.75L116.098 100.258Z"
          fill="#F27376"
        />
        <path
          d="M100.321 134.221L100.354 134.302L100.41 134.367L117.613 154.058L103.807 159.206L90.1973 140.442L80.6924 116.473L90.7656 109.827L100.321 134.221Z"
          fill="#E5E5E8"
          stroke="#E5E5E8"
        />
        <path
          d="M83.0051 165.802L78.8574 158.266"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M209.45 193.796L220.731 191.69"
          stroke="#1B1211"
          stroke-width="0.75"
          stroke-miterlimit="10"
        />
        <path
          d="M189.594 127.081C188.429 127.057 187.27 127.271 186.189 127.709C185.107 128.148 184.125 128.803 183.301 129.634C182.476 130.466 181.827 131.457 181.392 132.548C180.957 133.639 180.745 134.807 180.769 135.983C180.822 138.992 182.024 141.865 184.126 144.002C186.228 146.139 189.067 147.374 192.051 147.45C198.287 147.45 201.964 141.932 200.493 135.983C199.861 133.506 198.453 131.302 196.478 129.698C194.504 128.094 192.069 127.176 189.535 127.081M194.198 130.152C194.33 130.152 194.433 130.152 194.536 130.301C195.115 130.736 195.576 131.313 195.875 131.977C196.022 132.244 196.007 132.407 195.772 132.511C195.536 132.615 195.463 132.793 195.301 132.763C195.139 132.734 195.095 132.452 194.992 132.288C194.554 131.643 194.006 131.081 193.374 130.627L193.212 130.508C193.521 130.375 193.889 130.315 194.213 130.197M184.917 137.258C184.767 137.551 184.678 137.872 184.655 138.201C184.632 138.531 184.676 138.861 184.785 139.172L183.74 138.786C183.691 138.779 183.646 138.754 183.614 138.716C183.581 138.678 183.563 138.629 183.564 138.579C183.453 137.982 183.509 137.365 183.726 136.798C183.726 136.665 183.829 136.62 183.976 136.68L184.858 137.051C184.961 137.051 184.976 137.155 184.858 137.258M198.095 139.053C198.106 139.212 198.067 139.369 197.986 139.504C197.904 139.64 197.783 139.746 197.64 139.81C197.467 139.914 197.267 139.966 197.066 139.958C196.895 139.96 196.727 139.914 196.581 139.825C196.437 139.739 196.325 139.609 196.259 139.455C196.193 139.3 196.177 139.129 196.213 138.964C195.861 138.479 195.44 138.049 194.963 137.689C195.089 138.42 195.089 139.168 194.963 139.899C194.838 140.487 194.614 141.049 194.301 141.561C194.032 142.004 193.676 142.387 193.257 142.688C192.897 142.957 192.501 143.172 192.08 143.326C191.503 143.542 190.899 143.672 190.286 143.712C189.737 143.745 189.187 143.67 188.668 143.489C188.154 143.303 187.695 142.993 187.329 142.584C186.902 142.125 186.576 141.578 186.373 140.982C186.071 140.319 185.944 139.588 186.006 138.861C186.053 138.262 186.25 137.685 186.579 137.184C186.905 136.7 187.319 136.282 187.8 135.953C188.326 135.607 188.895 135.333 189.491 135.137C190.283 134.87 191.113 134.734 191.948 134.736C191.522 133.842 190.783 133.139 189.874 132.763C188.76 132.431 187.575 132.431 186.461 132.763C186.22 132.823 185.968 132.823 185.726 132.763C185.596 132.743 185.475 132.685 185.378 132.595C185.281 132.505 185.213 132.388 185.182 132.259C185.138 132.166 185.115 132.065 185.115 131.962C185.115 131.859 185.138 131.758 185.182 131.665C185.375 131.447 185.633 131.296 185.917 131.235C186.867 130.926 187.861 130.776 188.859 130.79C189.65 130.814 190.427 131.006 191.139 131.354C191.833 131.709 192.441 132.216 192.918 132.837C193.48 133.551 193.931 134.346 194.257 135.196C194.948 135.481 195.588 135.877 196.154 136.368C196.702 136.829 197.195 137.352 197.625 137.926C197.891 138.25 198.068 138.639 198.14 139.053M191.477 136.546C191.069 136.566 190.665 136.63 190.271 136.739C189.922 136.861 189.586 137.02 189.271 137.214C188.989 137.399 188.745 137.635 188.55 137.911C188.371 138.178 188.256 138.482 188.212 138.801C188.171 139.153 188.216 139.51 188.344 139.84C188.536 140.423 188.941 140.911 189.477 141.205C189.74 141.323 190.026 141.385 190.315 141.385C190.604 141.385 190.89 141.323 191.153 141.205C191.498 141.082 191.817 140.896 192.095 140.656C192.387 140.382 192.618 140.048 192.771 139.677C192.944 139.243 193.029 138.779 193.021 138.312C193.027 137.727 192.937 137.146 192.756 136.591C192.338 136.491 191.906 136.456 191.477 136.487M190.3 139.869C190.117 139.864 189.942 139.791 189.807 139.666C189.672 139.541 189.586 139.371 189.565 139.187C189.552 139.103 189.558 139.018 189.58 138.936C189.603 138.854 189.643 138.779 189.698 138.714C189.752 138.649 189.82 138.597 189.896 138.561C189.972 138.525 190.054 138.506 190.138 138.505C190.322 138.51 190.497 138.583 190.632 138.708C190.767 138.833 190.853 139.003 190.874 139.187C190.889 139.271 190.886 139.358 190.864 139.44C190.842 139.523 190.802 139.6 190.747 139.665C190.692 139.73 190.624 139.783 190.546 139.818C190.469 139.853 190.385 139.871 190.3 139.869Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_2433_8795"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(150 270.5) rotate(-89.8642) scale(123.5 150)"
        >
          <stop stop-color="#A48AFF" stop-opacity="0.75" />
          <stop offset="1" stop-color="#A48AFF" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2433_8795"
          x1="3.06977e-06"
          y1="233"
          x2="300"
          y2="233"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#604EA0" stop-opacity="0" />
          <stop offset="0.5" stop-color="#604EA0" />
          <stop offset="1" stop-color="#604EA0" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_2433_8795">
          <rect
            width="204"
            height="233"
            fill="white"
            transform="translate(48)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Happy;
